import { render, staticRenderFns } from "./CreditoPrecalificacion.vue?vue&type=template&id=97973672&scoped=true&lang=html&"
import script from "./CreditoPrecalificacion.vue?vue&type=script&lang=js&"
export * from "./CreditoPrecalificacion.vue?vue&type=script&lang=js&"
import style0 from "./CreditoPrecalificacion.vue?vue&type=style&index=0&id=97973672&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97973672",
  null
  
)

export default component.exports